import React from 'react';
import { useRecordContext } from 'react-admin';
import RangeField from 'shared-fields/RangeField';

export function Last30DaysTotalVideosField() {
  const record = useRecordContext() || {};
  const { stats } = record || {};
  const { last30DaysStats: { longVideos = 0, shortVideos = 0 } = { } } = stats || {};
  return (
    <RangeField value={longVideos + shortVideos} label="Videos" max={1000000} />
  );
}

Last30DaysTotalVideosField.defaultProps = {
  label: 'Videos',
};
